










import { Vue, Component, Prop } from 'vue-property-decorator';
import DaSupportPlanPageCore from '../../components/support_plan/DaSupportPlanPageCore.vue';
@Component({ components: { DaSupportPlanPageCore } })
export default class DaSupportPlanPage extends Vue {
  private user_id = '';
  private forDisplay = false;

  async created() {
    this.user_id = this.$route.query.user_id as string;
    console.log(this.user_id, this.$route.query);
  }
}
